import { graphql } from "gql/apollo";

export const GetIntegration = graphql(/* GraphQL */ `
	query GetGenetecIntegrationByGID($gid: GID!) {
		integration: getGenetecIntegrationByGID(params: { gid: $gid }) {
			gid
			name
			server
			username
			mapID
		}
	}
`);
